import { useTranslation } from "react-i18next";
import { FormField } from "@babackapp/ui/components/form";
import { Textarea } from "@babackapp/ui/components/textarea";
import type { ActionNodeReturnOrderNoteConfigDto } from "@babackapp/private-api-client/types";
import {
  PanelContainer,
  NodePanelProps,
} from "../../lib/panel/panel-container";
import { PanelContent } from "../../lib/panel/panel-content";
import { ReturnPlaceholdersHint } from "../../components/return-placeholders-hint";
import { useWorkflowForm } from "../../context/workflows-editor-workflows-context";
import { useNodeFormPath } from "../../hooks/use-node-form-path";

function PanelOrderNote() {
  const form = useWorkflowForm();
  const { t } = useTranslation("trackoffice");
  const fieldPath = useNodeFormPath("config.note");

  if (!fieldPath) {
    return null;
  }

  return (
    <PanelContent
      title={t("workflowsEditor.returnOrderNote.title", "Order note")}
      description={t(
        "workflowsEditor.returnOrderNote.description",
        "Replaces the note of the Shopify order linked to the return.",
      )}
    >
      <FormField
        control={form.control}
        name={fieldPath}
        render={({ field }) => (
          <Textarea
            value={(field.value as string) ?? ""}
            onChange={field.onChange}
            rows={4}
            className="text-xs"
            placeholder={t(
              "workflowsEditor.returnOrderNote.placeholder",
              "The note to write on the order…",
            )}
          />
        )}
      />
      <ReturnPlaceholdersHint />
    </PanelContent>
  );
}

export function ReturnOrderNoteActionNodePanel(
  props: NodePanelProps<ActionNodeReturnOrderNoteConfigDto>,
) {
  return (
    <PanelContainer nodeProps={props}>
      <PanelOrderNote />
    </PanelContainer>
  );
}
